import {useNotify} from "ra-core";
import {AutocompleteInput, ReferenceInput, ReferenceInputProps,} from "ra-ui-materialui";
import React from "react";
import {client} from "../../dataProvider";
import {generateError} from "../../shared/utils";

type ReferenceInputSubjectProps = Omit<
  ReferenceInputProps,
  "children" | "reference" | "sort"
>;

export const ReferenceInputMainSubject = (props: ReferenceInputSubjectProps) => {
  const notify = useNotify();
  const mustHaveProvince = async (subject_id: number | undefined) => {
    return undefined;
    if (subject_id) {
      return client(`subjects/${subject_id}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.province && response.province.length === 2) {
            return undefined;
          } else {
            return "Il soggetto non ha la provincia";
          }
        })
        .catch((error) => {
          generateError(error, notify);
          return "Verificare che il soggetto abbia ha la provincia";
        });
    } else {
      return undefined;
    }
  };
  /*
  const mustBeMainSubject = async (subject_id: number | undefined) => {
    if (subject_id) {
      return client(`subjects/${subject_id}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.main_subject == null || response.main_subject === "") {
            return true;
          } else {
            return false;
          }
        });
    } else {
      return false;
    }
  }
  */
  return (
    <ReferenceInput
      variant="outlined"
      {...(props as ReferenceInputProps)}
      reference="autocomplete/subject"
      sort={{ field: "business_name", order: "ASC" }}
      allowEmpty={props.allowEmpty === false ? false : true}
      validate={mustHaveProvince}
      isRequired={props.isRequired || props.required}
      filter={{ main_subject: null }}
    >
      <AutocompleteInput
        options={{ ...props.options }}
        optionText="label"
        onCreate={(filter) =>
          window.open(
            "/subjects/create",
            "_blank" // <- This is what makes it open in a new window.
          )
        }
      />
    </ReferenceInput>

  );
};
